import {
    productConfigurations
} from './config.js';
import {
    initScene
} from './3dlogic.js';

import {
    closeTab
} from './drawFunctions.js';


import {
    getSKU

} from './script.js';

export function generateUniqueId(type) {
    return type + '-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
}

//utils

export function adjustFadeVisibility() {
    const canvasContainer = document.getElementById('cardCarousel');
    const canvasWrapper = document.getElementById('main-container'); // Assuming this is the correct container
    const leftFade = document.getElementById('leftFade');
    const rightFade = document.getElementById('rightFade');

    let scrollLeft = canvasContainer.scrollLeft;
    let maxScrollLeft = canvasContainer.scrollWidth - canvasContainer.clientWidth;

    // If at the start, remove left fade
    if (scrollLeft <= 0) {
        leftFade.style.opacity = '0';
    } else {
        leftFade.style.opacity = '1';
    }

    // If at the end, remove right fade
    if (scrollLeft >= maxScrollLeft) {
        rightFade.style.opacity = '0';
    } else {
        rightFade.style.opacity = '1';
    }
}
export function updateArrowVisibility() {
    let is3DRenderingActive = false;
    closeTab();
    is3DRenderingActive = (currentPage === 'feature_3d');

    const validPages = Object.keys(productConfigurations[getSKU()]);

    // If there's only one page, hide both arrows and return
    if (validPages.length <= 1) {
        document.getElementById('leftArrow').style.display = 'none';
        document.getElementById('rightArrow').style.display = 'none';
        const canvasContainer = document.getElementById('cardCarousel');
        canvasContainer.ontouchstart = null;
        canvasContainer.ontouchmove = null;
        return;
    }

    const currentIndex = validPages.indexOf(currentPage);

    document.getElementById('leftArrow').style.display = currentIndex === 0 ? 'none' : 'block';
    document.getElementById('rightArrow').style.display = currentIndex === validPages.length - 1 ? 'none' : 'block';

    // Update the flag for the 3D page.
}

export function onWindowResize() {
    const container = document.getElementById('threeJSContainer');

    // Check if container is available
    if (!container) {
        console.error('threeJSContainer element not found!');
        return;
    }

    // Adjust the camera's aspect ratio
    camera.aspect = container.offsetWidth / container.offsetHeight;
    camera.updateProjectionMatrix();

    // Adjust the renderer's size
    renderer.setSize(container.offsetWidth, container.offsetHeight);
}




export function revertAction() {
    if (actionStack.length > 0) {
        const action = actionStack.pop();

        console.log('Action:', action); // Log the action for debugging
        console.log('Action element type:', typeof action.element); // Log the type of action.element

        if (action.type === 'stickerAdd') {
            let stickerID;

            // Check if action.element is an SVG.js element
            if (action.element && typeof action.element.attr === 'function') {
                stickerID = action.element.attr('data-sticker-id');
            } else if (action.element && typeof action.element.getAttribute === 'function') {
                stickerID = action.element.getAttribute('data-sticker-id');
            }

            if (stickerID) {
                const product_data = document.getElementById('cardType').value;

                // Remove the sticker from the canvas
                action.element.remove();

                // Update the cardState to reflect the removal
                cardState[product_data][currentPage].stickers = cardState[product_data][currentPage].stickers.filter(sticker => sticker.id !== stickerID);
            } else {
                console.error("Failed to retrieve sticker ID from action.element:", action.element);
            }
        } else if (action.type === 'textEdit') {
            // Check if action.element has the text method
            if (action.element && typeof action.element.text === 'function') {
                action.element.text(action.oldText);
                action.element.fire('textChanged');
            } else {
                console.error("action.element doesn't have the text method:", action.element);
            }
        } else if (action.type === 'frameChange') {
            // If the action is a frame change, revert back to the old frame
            applyFrameToPage(action.oldFrame);
        }
    }
}

export function resetCard() {
    const product_data = document.getElementById('cardType').value;

    // Reset the card state for the current type to its default configuration
    cardState[product_data] = {
        front_cover: {
            text: "",
            name: "",
            stickers: []
        },
        inside_left: {
            text: "",
            name: "",
            stickers: []
        },
        inside_right: {
            text: "",
            name: "",
            stickers: []
        }
    };

    // Update the card template
    updateCardTemplate(currentPage);

    // Clear the action stack
    actionStack = [];
}


export function saveCard() {
    // Scale the SVG to create a high-resolution version
    const scale = 4;
    const width = draw.width() * scale;
    const height = draw.height() * scale;
    const scaledSvg = draw.clone().size(width, height);

    // Get the SVG source as a string
    const svgSource = scaledSvg.svg();

    // Create a Blob object from the SVG source
    const blob = new Blob([svgSource], {
        type: 'image/svg+xml;charset=utf-8'
    });

    // Create an anchor element with a download attribute
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'card.svg'; // Filename for the download
    a.style.display = 'none';

    // Append the anchor element to the body and click it to start the download
    document.body.appendChild(a);
    a.click();

    // Clean up by removing the anchor element and the cloned SVG
    document.body.removeChild(a);
    scaledSvg.remove();
}



export function open3DPreview() {

  
    initScene();

    const preview3DElement = document.getElementById('threeJSContainer');

    if (preview3DElement) {
        const position = preview3DElement.getBoundingClientRect();
        console.log('Preview3D position:', position);

        const canvasContainer = document.getElementById('canvas-container');

        // Since getBoundingClientRect() provides the position relative to the viewport,
        // we subtract the container's left position to get the position relative to the container.
        const scrollTo = position.left - canvasContainer.getBoundingClientRect().left;

        canvasContainer.scrollTo({
            left: scrollTo,
            behavior: 'smooth'
        });

    } else {
        console.log("The preview3D div was not found in the DOM.");
    }
}
// Function to download SVG and send it to server for conversion to TIFF
// Function to download SVG and send it to server for conversion to TIFF
// Function to download SVG and send it to server for conversion to TIFF
// Function to download SVG and send it to server for conversion to TIFF


async function imgToDataURL(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // Handle CORS
        img.onload = function () {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = function (event) {
            // Reject with the event to diagnose the issue
            reject(event);
        };
        img.src = url;
    });
}

function includeBase64FontInSVG(node, fontName, base64FontString) {
    const styleElement = document.createElementNS("http://www.w3.org/2000/svg", "style");
    styleElement.textContent = `
        @font-face {
            font-family: '${fontName}';
            src: url(data:font/woff2;base64,${base64FontString}) format('woff2');
        }
    `;
    node.insertBefore(styleElement, node.firstChild);
}

function includeFontFaceInSVG(node, fontName, fontUrl, formatType = 'woff2') {
    const styleElement = document.createElementNS("http://www.w3.org/2000/svg", "style");
    styleElement.textContent = `
        @font-face {
            font-family: '${fontName}';
            src: url(${fontUrl}) format('${formatType}');
        }
    `;
    node.insertBefore(styleElement, node.firstChild);
}


// Function to convert font to Base64 (You'll need to implement this)
async function convertFontToBase64(fontName) {
    try {
        // Replace spaces with '+' to construct the correct Google Fonts URL
        const fontNameQuery = fontName.replace(/ /g, '+');

        // Fetch the CSS for the font from Google Fonts
        
        const fontCssResponse = await fetch(`https://fonts.googleapis.com/css2?family=${fontNameQuery}&display=swap`);
        if (!fontCssResponse.ok) throw new Error(`Cannot fetch the CSS for the font: ${fontName}`);
        const cssText = await fontCssResponse.text();

        // Extract the URL of the .woff2 or .ttf file from the CSS text
        const urlMatch = cssText.match(/url\((https:\/\/[^)]+\.woff2)\)/);
        if (!urlMatch) throw new Error('Could not find font URL in the CSS.');

        const fontUrl = urlMatch[1];

        // Fetch the font file itself
        const fontResponse = await fetch(fontUrl);
        if (!fontResponse.ok) throw new Error(`Cannot fetch the font file from: ${fontUrl}`);
        const blob = await fontResponse.blob();

        // Convert the Blob to a Base64 string
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error(`Error in convertFontToBase64 for font ${fontName}:`, error);
        throw error; // Rethrow the error so that the calling function knows something went wrong
    }
}// Define a helper function to convert a Blob to a Data URL
const blobToDataUrl = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('Error converting blob to data URL'));
      reader.readAsDataURL(blob);
    });
  };
  
  async function embedFontsInSVG(svgNode) {
    // Find all style elements inside the SVG
    const styleElements = svgNode.querySelectorAll('style');
    for (const styleElement of styleElements) {
      let styleSheet = styleElement.textContent;
  
      // Match all font URL references within the style content
      const fontUrlRegex = /url\(['"]?(https:\/\/fonts\.googleapis\.com\/[^)'"]+)['"]?\)/g;
      let fontUrls = styleSheet.match(fontUrlRegex);
  
      if (fontUrls) {
        // Load and embed each font as base64
        for (let fontUrl of fontUrls) {
          // Fetch the actual font file
          try {
            const response = await fetch(fontUrl);
            if (!response.ok) {
              throw new Error(`Failed to load font from: ${fontUrl}`);
            }
            const contentType = response.headers.get('Content-Type');
            if (!contentType || !contentType.includes('font')) {
              throw new Error(`Fetched file at ${fontUrl} is not a font`);
            }
            const fontBlob = await response.blob();
            const fontDataUrl = await blobToDataUrl(fontBlob);
            // Replace the URL with the base64-encoded data
            styleSheet = styleSheet.replace(new RegExp(`url\\(['"]?${fontUrl.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')}['"]?\\)`, 'g'), `url('${fontDataUrl}')`);
          } catch (error) {
            // Propagate the error to allow external handling
            throw error;
          }
        }
        // Update the text content of the style element with the new stylesheet
        styleElement.textContent = styleSheet;
      }
    }
    return true;
  }
  
  

// Call the download function with await or then() if used inside an async function or top-level code.
// Example:
// downloadSVG('elementId', 'filename').catch(console.error);

let simulationInterval;

function simulateProgress(onProgress) {
    let progress = 0;

    function update() {
        progress += 0.3; // Increment by 0.5% for this example, adjust as needed
        if (progress >= 95) {
            progress = 99; // Stop at 99%
            showStillProcessingMessage(); // Show the "still processing" message
        }

        onProgress(progress);
    }

    simulationInterval = setInterval(update, 140); // Update every 100ms
}

function showStillProcessingMessage() {
    const messageElement = document.getElementById('stillProcessingMessage');
    messageElement.style.display = 'block';
}

function hideStillProcessingMessage() {
    const messageElement = document.getElementById('stillProcessingMessage');
    messageElement.style.display = 'none';
}


function stopSimulation() {
    clearInterval(simulationInterval);
}

function showSVGPreview(blob, previewElementId) {
    const previewElement = document.getElementById(previewElementId);
    if (previewElement) {
        const url = URL.createObjectURL(blob);
        if(previewElement.tagName.toLowerCase() === 'img') {
            previewElement.src = url;
            previewElement.style.display = 'block'; // Make sure to display the element if it was hidden
        } else {
            // For non-img containers, create an <img> and append it
            const img = new Image();
            img.src = url;
            img.onload = function() {
                previewElement.innerHTML = ''; // Clear any existing content
                previewElement.appendChild(img); // Append the new image
                previewElement.style.display = 'block'; // Display the element
            };
        }
    } else {
        console.error(`Element with ID ${previewElementId} not found.`);
    }
}


async function convertAllImagesToBase64(node) {
    const imageElements = node.querySelectorAll('image');
    const promises = Array.from(imageElements).map(async (imgElement) => {
        const url = imgElement.getAttribute('href') || imgElement.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
        try {
            const base64data = await getBase64Image(url);
            imgElement.setAttribute('href', base64data);
            imgElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', base64data); // Handle xlink:href as well
        } catch (error) {
            console.error(`Failed to convert image at ${url} to Base64. Error:`, error);
        }
    });
    await Promise.all(promises);
}

async function getBase64Image(imgUrl) {
    const response = await fetch(imgUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
function generateRandomId() {
    return Math.floor(1000 + Math.random() * 9000); // This will generate a number between 1000 and 9999
}



const imageUrls = []; // Array to store the URLs of the converted images
const BASE_API_URL = "https://i.expresscreations.co.uk/image";

const getElement = (id) => document.getElementById(id);

function updateProgress(progress, progressBar, progressText) {
  progressBar.style.width = `${progress}%`;
  progressText.textContent = `${progress.toFixed(2)}%`;
}

function showModal(modal, show = true) {
  modal.style.display = show ? "flex" : "none";
}

async function sendBlobToServer(blob, ecid,elementId) {
    const loadingAnimation = document.getElementById('loadingAnimation'); // Ensure this is the ID of your loading animation element
    const fileNameElement = document.getElementById('fileName'); // Update this with the correct ID if necessary

    // Show the loading animation
    loadingAnimation.style.display = 'flex';

    try {
        const SKU = getSKU();
        const formData = new FormData();
        const print_type = productConfigurations[SKU][currentPage].print_type;
        const product_type = productConfigurations[SKU][currentPage].type;
        const transparent = productConfigurations[SKU][currentPage].transparent;

        formData.append("svg", blob);
        formData.append("print_type", print_type);
        formData.append("sku", SKU);
        formData.append("ecid", ecid);
        formData.append("currentPage", elementId);
        formData.append("type", product_type);
        formData.append("transparent", transparent);
        fileNameElement.textContent = fileName;
        fileNameElement.style.display = "block";

        console.log('Sending blob to server for conversion:', ecid);
        const response = await fetch(`${BASE_API_URL}/process`, {
            method: "POST",
            body: formData,
        });

        console.log('Awaiting server response for file:', ecid);
        if (!response.ok) {
            throw new Error(`Server responded with status: ${response.status}`);
        }

        const responseJson = await response.json();
        const imageUrl = { id: ecid, url: responseJson.url };
        console.log('File converted successfully, image URL:', imageUrl);

        // Hide the loading animation
        loadingAnimation.style.display = 'none';

        return imageUrl;

    } catch (error) {
        console.error("Error in conversion for file:", fileName, error);
        loadingAnimation.style.display = 'none';
        alert('Error processing the file. Please try again.');
        throw error; // Re-throw the error for further handling
    }
}

function downloadBlob(fileUrl, fileName) {
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = fileName || 'download';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

function downloadURL(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}


async function captureAndDraw(elementId) {
    const container = getElement(elementId);
    if (!container) {
      console.error(`Element with ID ${elementId} not found.`);
      throw new Error(`Element with ID ${elementId} not found.`);
    }
    const svgNode = container.querySelector('svg');
    if (!svgNode) {
      console.error(`SVG not found inside container with ID ${elementId}.`);
      throw new Error(`SVG not found inside container with ID ${elementId}.`);
    }
    await convertAllImagesToBase64(svgNode);
   // await embedFontsInSVG(svgNode);
  
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgNode);
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const SKU = getSKU();

    const ecid = document.getElementById('ecid_session').value;
    const fileName = `${ecid}-${SKU}-${elementId}`;
  
    return await sendBlobToServer(blob, ecid,elementId);
  }


export async function processProduct(type = 'card') {
    return new Promise(async (resolve, reject) => {

    
        console.log('starting');
        try {
            const SKU = getSKU();
            console.log(SKU);
            console.log(productConfigurations);
            const productConfig = productConfigurations[SKU][currentPage];
          
            const mediumEffect = productConfig.medium_effect;
         
            let originalFilter = null; // Variable to store original filter value
         
            const imageUrls = []; // Array to store the URLs of captured images

               // Hide the background effect if necessary
               if (mediumEffect === 'acrylic') {
                const backgroundRectElement = document.querySelector(`#${currentPage}-customBackgroundRect`);
                if (backgroundRectElement) {
                    backgroundRectElement.style.display = 'none';
                    backgroundRectElement.setAttribute('fill', 'none');
                }
                
                const svgElement = document.getElementById(`${currentPage}-acrylicEffectFilter`);
                if (svgElement && svgElement.hasAttribute('filter')) {
                    originalFilter = svgElement.getAttribute('filter');
                    svgElement.removeAttribute('filter');
                }
            }
            // Check the product type and handle accordingly
            if (productConfigurations[SKU][currentPage].type === 'card') {
                console.log('Processing a card...');

                // Capture and draw the front cover
                const frontCoverUrlObject = await captureAndDraw('front_cover-container');
                if (!frontCoverUrlObject) {
                    throw new Error('Front cover image URL not found');
                }
                imageUrls.push(frontCoverUrlObject.url); // Add the URL to the array

                // Capture and draw the inside left cover
                const insideLeftUrlObject = await captureAndDraw('inside_left-container');
                if (!insideLeftUrlObject) {
                    throw new Error('Inside left cover image URL not found');
                }
                imageUrls.push(insideLeftUrlObject.url); // Add the URL to the array

                // Capture and draw the inside right cover
                const insideRightUrlObject = await captureAndDraw('inside_right-container');
                if (!insideRightUrlObject) {
                    throw new Error('Inside right cover image URL not found');
                }
                imageUrls.push(insideRightUrlObject.url); // Add the URL to the array
            } else {
                console.log('Processing a single item...');
                const singleItemUrlObject = await captureAndDraw('front_cover-container');
                if (!singleItemUrlObject) {
                    throw new Error('Single item image URL not found');
                }
                imageUrls.push(singleItemUrlObject.url); // Add the URL to the array
            }

            if (mediumEffect === 'acrylic') {
                // Optionally, reset the display property of the backgroundRectElement if needed
                const backgroundRectElement = document.querySelector(`#${currentPage}-customBackgroundRect`);
                if (backgroundRectElement) {
                    backgroundRectElement.style.display = ''; // Reset display property to default
                    backgroundRectElement.setAttribute('fill', '#fff');

                }

                // Reapply the original filter to the SVG element if it was removed earlier
                const svgElement = document.getElementById(`${currentPage}-acrylicEffectFilter`);
                if (svgElement && originalFilter) {
                    svgElement.setAttribute('filter', originalFilter);
                }
            }


            // Log the collected image URLs
            console.log('Collected image URLs:', imageUrls);
            if (imageUrls.length > 0) {
                resolve(imageUrls[0]); // Resolve with the first URL (ecid)
            } else {
                reject('No image URLs collected');
            }
        } catch (error) {
            console.error("An error occurred while processing the product:", error);
            reject(error.message);
        }
    });
}

window.addEventListener('processProductEvent', function(e) {
    console.log('A');
    processProduct(e.detail.type).then(ecid => {
        console.log("Product processed successfully, ECID:", ecid);
        document.getElementById('ecid').value = ecid;
        // Dispatch an event indicating success
        window.dispatchEvent(new CustomEvent('productProcessed', { detail: { success: true, ecid: ecid }}));
    }).catch(error => {
        console.error("Error in processing product:", error);
        // Dispatch an event indicating failure
      //  window.dispatchEvent(new CustomEvent('productProcessed', { detail: { success: false, error: error }}));
    });
});


export async function captureSVGtoImages(type = 'card') {
    alert('render');
    try {
        const SKU = getSKU();
        const joinImagesResults = [];
        const printType = productConfigurations[SKU][currentPage].print_type;
        const productConfig = productConfigurations[SKU][currentPage];
        const mediumEffect = productConfig.medium_effect;


        let backgroundEffectProperties = null;


        if (mediumEffect === 'acrylic') {
            const backgroundRectElement = document.querySelector(`#${currentPage}-customBackgroundRect`);
            if (backgroundRectElement) {
                // Remove the background effect by hiding the element instead of removing it
                backgroundRectElement.style.display = 'none';
            }
        }


        let backCoverFilename;
        if (printType.includes('a4')) {
            backCoverFilename = 'ec_back_cover_a4.tif';
        } else if (printType.includes('a5')) {
            backCoverFilename = 'ec_back_cover_a5.tif';
        } else if (printType.includes('a3')) {
            backCoverFilename = 'ec_back_cover_a3.tif';
        } else {
            // Default case or an error handling
            backCoverFilename = 'ec_back_cover_default.tif';
        }

        if (productConfigurations[SKU][currentPage].type === 'card') {
            console.log('card');
            const frontCoverUrlObject = await captureAndDraw('front_cover-container');
            if (!frontCoverUrlObject) {
                throw new Error('Front cover image URL not found');
            }

            // Use the determined back cover filename
            const backCoverUrlObject = { url: backCoverFilename }; 

            console.log(frontCoverUrlObject.url);
            console.log(backCoverUrlObject.url);

            // Join front and back cover images and store the result
            const frontAndBackCoverResult = await joinAndDownloadImages(
                [backCoverUrlObject.url, frontCoverUrlObject.url], 
                'front_and_back.tiff'
            );
            joinImagesResults.push(frontAndBackCoverResult);

            // Now repeat the process for the inside covers
            const insideLeftUrlObject = await captureAndDraw('inside_left-container');
            if (!insideLeftUrlObject) {
                throw new Error('Inside left cover image URL not found');
            }

            const insideRightUrlObject = await captureAndDraw('inside_right-container');
            if (!insideRightUrlObject) {
                throw new Error('Inside right cover image URL not found');
            }

            // Join inside cover images and store the result
            const insideCoversResult = await joinAndDownloadImages(
                [insideLeftUrlObject.url, insideRightUrlObject.url], 
                'inside_left_and_right.tiff'
            );
            joinImagesResults.push(insideCoversResult);
        } else {
            console.log('single');
            const frontCoverUrlObject = await captureAndDraw('front_cover-container');
            if (!frontCoverUrlObject) {
                throw new Error('Front cover image URL not found');
            }
            console.log(frontCoverUrlObject.url, SKU);
            downloadBlob('https://i.expresscreations.co.uk/uploads/' + frontCoverUrlObject.url, SKU);
        }

        
        // After both joins are complete, return the URLs
        if (joinImagesResults.length === 2) {
            // Send the file names to the server to convert them into a PDF
            const pdfResult = await convertToPDF(joinImagesResults[0], joinImagesResults[1]);
            
            return pdfResult; // This should be the URL to the generated PDF
        }

        if (mediumEffect === 'acrylic') {
            const backgroundRectElement = document.querySelector(`#${currentPage}-customBackgroundRect`);
            if (backgroundRectElement) {
                backgroundRectElement.style.display = ''; // Reset display property to default
            }
        }


    } catch (e) {
        console.error("An error occurred while capturing SVG to images:", e);
    }
}

function reattachBackgroundEffect(containerId, properties, config) {
    const drawInstance = SVG().addTo(`#${containerId}`).size('100%', '100%');
    const backgroundRect = drawInstance.rect(config.page_size).move(0, 0).fill(properties.fill).attr({ id: properties.id });
    // Reapply other properties as necessary
}

async function joinAndDownloadImages(imageUrls, filename) {
    console.log(imageUrls);
    const payload = {
        images: imageUrls
    };

    try {
        const response = await fetch('https://i.expresscreations.co.uk/image/join_images', {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Check if the response is JSON
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            const json = await response.json();
            console.log('Joined images response:', json);
            return json.filename; // Assuming JSON has a filename field
        } else {
            // Response is not JSON, handle it as text
            const text = await response.text();
            console.error('Unexpected response:', text);
            return null; // Handle non-JSON responses as needed
        }
    } catch (error) {
        console.error('Error sending images for joining:', error);
        return null;
    }
}
async function convertToPDF(frontTiffFilename, backTiffFilename) {
    // Create a payload object with filenames
    const payload = {
        front: frontTiffFilename,
        back: backTiffFilename
    };

    try {
        // Send the file names to the server
        const response = await fetch('https://i.expresscreations.co.uk/image/join_tiffs_to_pdf', {
            method: 'POST',
            body: JSON.stringify(payload), // Send the JSON payload
            headers: {
                'Content-Type': 'application/json' // Set the content type to JSON
            }
        });

        if (response.ok) {
            const blob = await response.blob();
            const pdfUrl = URL.createObjectURL(blob);
            console.log('PDF created:', pdfUrl);

            // Create a new anchor element to trigger the download
            const downloadLink = document.createElement('a');
            downloadLink.href = pdfUrl;
            downloadLink.download = 'converted.pdf'; // The name of the downloaded file
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            
            return pdfUrl; // This should be the URL to the generated PDF blob
        } else {
            console.error('Error converting TIFFs to PDF:', response.statusText);
            return null; // Handle the error appropriately
        }
    } catch (error) {
        console.error('Error sending TIFF filenames for PDF conversion:', error);
        return null; // Handle the error appropriately
    }
}
